module.exports = __webpack_public_path__ + "static/media/nl.f163721e.svg";